import classnames from 'classnames';
import {
  PullQuoteEmbed as V3PullQuoteEmbed,
  PullQuoteEmbedProps,
} from '@stadionhq-v3/base-ui';
import styles from './pullQuoteEmbed.module.scss';

export type ExtendedPullQuoteEmbedProps = PullQuoteEmbedProps & {
  compact?: boolean;
};

const PullQuoteEmbed = ({ compact, ...props }: ExtendedPullQuoteEmbedProps) => {
  const classes = classnames([
    styles.pullQuoteEmbedTokens,
    styles.pullQuoteEmbed,
    props.theme?.themeId ? styles[props.theme.themeId] : styles.default1,
    compact && styles.compact,
  ]);

  return <V3PullQuoteEmbed {...props} classNames={[classes]} />;
};

export default PullQuoteEmbed;
